import React from 'react';
import PropTypes from 'prop-types';

export default function AddressList({ addresses, showDistributionAddress }) {
  return (
    <>
      <span className="send-address-date">{showDistributionAddress}</span>
      <ul className="distribution-center-address" data-testid="distribution-return-address">
        {addresses.map((address, index) => <li key={`DISTRI_ADDRESS_${index + 1}`}>{address}</li>)}
      </ul>
    </>
  );
}

AddressList.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.string).isRequired,
  showDistributionAddress: PropTypes.string.isRequired,
};
